import React, { useState } from 'react';
import { getImageUrl, PLACEHOLDER } from '../utils/imageHelper';

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src?: string | null;
};

export default function FallbackImage({ src, alt, className, ...rest }: Props) {
  const initial = getImageUrl(src);
  const [current, setCurrent] = useState(initial);
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      src={current}
      alt={alt}
      className={className}
      onError={() => {
        if (current !== PLACEHOLDER) setCurrent(PLACEHOLDER);
      }}
      {...rest}
    />
  );
}
